import http from './http';

export function fetchDashboardOverview(params) {
  return http.get('/dashboard/overview', { params });
}
